import { createContext, ReactNode, useContext } from 'react';
import { useRouter } from 'next/router';

import { getUserTypeCookie } from '~/features/cookies/utils/get-user-type-cookie';
import { useUserExperience } from '~/features/user/hooks/use-user-experience';
import { useClientRender } from '~/hooks/use-client-render';

const StickyPriceTrackContext = createContext<boolean>(false);

export function StickyPriceTrackProvider({
  children,
  isFree,
  isUnavailable,
}: {
  children: ReactNode;
  isFree?: boolean;
  isUnavailable?: boolean | null;
}) {
  const isClient = useClientRender();
  const router = useRouter();
  const isEnterpriseUser = isClient && getUserTypeCookie() === 'enterprise';
  const hasPricingSection = isFree !== true && isUnavailable !== true;
  const { userExperience, userExperienceIsFetched } = useUserExperience({
    disabled: !hasPricingSection,
  });
  const isValidUserState =
    (userExperienceIsFetched ? userExperience?.hasActiveSubscription !== true : true) && !isEnterpriseUser;
  // Note: don't run on enrollment pages.
  const isValidPath = isClient ? router.asPath.startsWith('/course/') : true;
  return (
    <StickyPriceTrackContext.Provider value={isValidUserState && isValidPath && hasPricingSection}>
      {children}
    </StickyPriceTrackContext.Provider>
  );
}

export function useStickyPriceTrackRendered() {
  return useContext(StickyPriceTrackContext);
}
